import React, { useEffect, useRef, useState } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import FBIntegrationService from '../services/FBIntegrationService';
import $ from 'jquery';
import 'datatables.net';


function AddFBIntegtarion({ ClientId, props }) {
 // const { id } = useParams(); 
  const [form, setForm] = useState({
    appId:"",
    appSecret:"",
    accessToken:"",
    leadGenId:"",
    clientId: ClientId
  });

  const [formError, setFormError] = useState({});
  const [FbIntegrations, setFbIntegration] = useState([]);
  const navigate = useNavigate();
  const toast = useRef(null);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value,  });
  setFormError((prevErrors) => ({ ...prevErrors, [name]: '' })); 
  };
  
  async function saveFBIntegration() {
    const errors = {};
    Object.keys(form).forEach(key => {
      if (!form[key].trim()) {
        errors[key] = `Please enter ${key}`;
      }
    });

    setFormError(errors); 
    if (Object.keys(errors).length > 0) {
      console.error('Validation errors:', errors);
      return;
    }
    const requestData = {
      appId: form.appId,
      appSecret: form.appSecret,
      accessToken: form.accessToken,
      leadGenId: form.leadGenId,
      isActive: true,
      clientId: ClientId
    };
    try {
       {
        await FBIntegrationService.createFbIntegration(requestData);
        toast.current.show({ severity: 'success', summary: 'Success', detail: ' FBIntegration added successfully' });
        await this.fetchFbIntegrations();
        this.props.setActiveTab('integration'); 
    }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const validationErrors = error.response.data.errors;
        setFormError(validationErrors);
      } else {
        console.log("Error saving Contractor:", error);
      }
    }
  }

  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 

    Object.keys(form).forEach((key) => {
      if (!form[key]?.trim()) {
        errors[key] = `Please enter ${key}`;
      }
    });
    
    if (form.email && !emailRegex.test(form.email)) {
      errors.email = "Please enter a valid email address";
    }

    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
        saveFBIntegration();
        resetForm();
    }
  };

  function resetForm() {
    setForm({
        appId:"",
        appSecret:"",
        accessToken:"",
        leadGenId:"",
        clientId: ""
    });
    setFormError({});
  }


  useEffect(() => {    
    const fetchFbIntegrations = async () => {
      try {
        debugger
        const fbintegrations = await FBIntegrationService.getFBIntegrationsAsyncByClientId(ClientId);
        setFbIntegration(fbintegrations);
      } catch (error) {
        console.error('Error fetching Users: ', error);  
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch fbintegrations data' });
      }
    };
    fetchFbIntegrations();
    setTimeout(() => {
      $('#tableData').DataTable();
    }, 0);
  }, [ClientId, saveFBIntegration]);

  function renderFBIntegrations() {
    return FbIntegrations.map((fbIntegration) => {
    return (
      <tr key={fbIntegration.id}>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{fbIntegration.appId}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{fbIntegration.appSecret}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{fbIntegration.accessToken}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{fbIntegration.leadGenId}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold"><button
            className="btn btn-outline-dark btn-sm"
            onClick={() => navigate(`/editfbintegration/${fbIntegration.id}`)}
          >
            <i className="pi pi-pencil" style={{ fontSize: '1.5rem' }}></i>
          </button>
          </span>
        </td>
      </tr>
    );
  });
}

  return (
    <div>
        <Toast ref={toast} />
        <form onSubmit={onSubmit}> 
        <div className="row m-2 p-2">
            <div className="card text-center mx-auto">
                <div className="card-body text-start text-dark">
                <div className="form-group row">
          <div className="form-group row">
          <label className="col-lg-2" htmlFor="appId">
         App Id
            </label>
            <div className="col-lg-4">
          <input
            type="text"
            name="appId"
            id="appId"
            className="form-control"
            value={form.appId}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.appId}</p>
          </div>
          <label className="col-lg-2" htmlFor="appSecret">
        App Secret
            </label>
            <div className="col-lg-3">
          <input
            type="text"
            name="appSecret"
            id="appSecret"
            className="form-control"
            value={form.appSecret}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.appSecret}</p>
          </div>
        </div>

        <div className="form-group row">
          <label className="col-lg-2" htmlFor="accessToken">
         Access Token
            </label>
            <div className="col-lg-4">
          <input
            type="text"
            name="accessToken"
            id="accessToken"
            className="form-control"
            value={form.accessToken}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.accessToken}</p>
          </div>
          <label className="col-lg-2" htmlFor="leadGenId">
        LeadGen Id
            </label>
            <div className="col-lg-3">
          <input
            type="text"
            name="leadGenId"
            id="leadGenId"
            className="form-control"
            value={form.leadGenId}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.leadGenId}</p>
          </div>
        </div>
        </div>
                </div>
                <div className="card-footer text-muted bg-light">
                  <button type="submit"  className="btn btn-save btn-dark text-white"> <i className="pi pi-plus"></i>Submit</button>
                </div>
            </div>
        </div>

        </form>
        <br></br>
      <div class="col-12">
          <div class="card my-4">
            <div class="card-body px-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0" id="tableData">
                  <thead>
                    <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">App Id</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">App Secret</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Access Token </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Lead GenId</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Action</th> 
                    </tr>
                  </thead>
                  <tbody>
                  {renderFBIntegrations()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default AddFBIntegtarion;
